module.exports = __webpack_public_path__ + "static/img/celoscope-14.05a1768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-14.jpg
// module id = ajoD
// module chunks = 51